import { render, staticRenderFns } from "./TheMainAgentContent.vue?vue&type=template&id=53994332&scoped=true"
import script from "./TheMainAgentContent.vue?vue&type=script&lang=js"
export * from "./TheMainAgentContent.vue?vue&type=script&lang=js"
import style0 from "./TheMainAgentContent.vue?vue&type=style&index=0&id=53994332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53994332",
  null
  
)

export default component.exports